import { gql } from '@apollo/client';

export const CATEGORIES = gql`
  query Categories(
    $clientCode: String!
    $filterParams: JSON
    $fullMode: Boolean = false
  ) {
    categories(
      clientCode: $clientCode
      filterParams: $filterParams
      fullMode: $fullMode
    ) {
      data
    }
  }
`;

export const CATEGORIES_QUERY_NAME = 'Categories';

export const CATEGORY = gql`
  query Category($clientCode: String!, $id: ID!) {
    category(clientCode: $clientCode, id: $id) {
      data
    }
  }
`;

export const CATEGORY_QUERY_NAME = 'Category';

export const CREATE_CATEGORY = gql`
  mutation CreateCategory(
    $clientCode: String!
    $name: String
    $type: String
    $parentId: ID
    $rootId: ID
  ) {
    createCategory(
      clientCode: $clientCode
      name: $name
      type: $type
      parentId: $parentId
      rootId: $rootId
    ) {
      success
      error
      data
    }
  }
`;

export const BULK_CREATE_CATEGORY = gql`
  mutation BulkCreateCategory(
    $clientCode: String!
    $names: String
    $type: String
    $parentId: ID
    $rootId: ID
    $isAutoGenerated: Boolean
    $isTokenized: Boolean
    $productField: String
    $wordMatch: String
    $match: String
    $caseSensitive: Boolean
    $basis: String
    $key: String
    $linkedRules: [ID]
  ) {
    bulkCreateCategory(
      clientCode: $clientCode
      names: $names
      type: $type
      parentId: $parentId
      rootId: $rootId
      isAutoGenerated: $isAutoGenerated
      isTokenized: $isTokenized
      productField: $productField
      wordMatch: $wordMatch
      match: $match
      caseSensitive: $caseSensitive
      basis: $basis
      key: $key
      linkedRules: $linkedRules
    ) {
      success
      error
      data
    }
  }
`;

export const UPDATE_CATEGORY = gql`
  mutation UpdateCategory(
    $clientCode: String!
    $_id: ID!
    $name: String
    $type: String
    $associations: JSON
    $properties: JSON
    $templates: JSON
  ) {
    updateCategory(
      clientCode: $clientCode
      _id: $_id
      name: $name
      type: $type
      associations: $associations
      properties: $properties
      templates: $templates
    ) {
      success
      error
      data
    }
  }
`;

export const DELETE_CATEGORY = gql`
  mutation DeleteCategory(
    $clientCode: String!
    $_id: ID
    $associations: JSON
    $categories: [String]
  ) {
    deleteCategory(
      clientCode: $clientCode
      _id: $_id
      associations: $associations
      categories: $categories
    ) {
      success
      error
      data
    }
  }
`;

export const ADD_ASSOCIATITON_ATTRIBUTE = gql`
  mutation AddAssociationAttribute(
    $clientCode: String!
    $_id: ID!
    $attributeIds: [ID!]
  ) {
    addAssociationAttribute(
      clientCode: $clientCode
      _id: $_id
      attributeIds: $attributeIds
    ) {
      success
      error
      data
    }
  }
`;

export const REMOVE_ASSOCIATITON_ATTRIBUTE = gql`
  mutation RemoveAssociationAttribute(
    $clientCode: String!
    $_id: ID!
    $attributeIds: [ID!]
  ) {
    removeAssociationAttribute(
      clientCode: $clientCode
      _id: $_id
      attributeIds: $attributeIds
    ) {
      success
      error
      data
    }
  }
`;
